/* tslint:disable */
/* eslint-disable */
/**
 * PartnerLink
 * 
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Courier } from './Courier';
import {
    CourierFromJSON,
    CourierFromJSONTyped,
    CourierToJSON,
} from './Courier';
import type { CourierUser } from './CourierUser';
import {
    CourierUserFromJSON,
    CourierUserFromJSONTyped,
    CourierUserToJSON,
} from './CourierUser';

/**
 * 
 * @export
 * @interface PartnerLink
 */
export interface PartnerLink {
    /**
     * 
     * @type {string}
     * @memberof PartnerLink
     */
    id?: string;
    /**
     * ID of the warehouse tenant (Courier)
     * @type {string}
     * @memberof PartnerLink
     */
    warehouseTenantId: string;
    /**
     * ID of the sub-courier tenant (Courier)
     * @type {string}
     * @memberof PartnerLink
     */
    subCourierTenantId: string;
    /**
     * List of permissions/scopes granted to the sub-courier
     * @type {Array<string>}
     * @memberof PartnerLink
     */
    scopes?: Array<string>;
    /**
     * Current status of the partner link
     * @type {string}
     * @memberof PartnerLink
     */
    status: string;
    /**
     * ID of the user who created this partner link
     * @type {string}
     * @memberof PartnerLink
     */
    createdBy: string;
    /**
     * When the partner link was created
     * @type {Date}
     * @memberof PartnerLink
     */
    createdAt: Date;
    /**
     * When the partner link was last updated
     * @type {Date}
     * @memberof PartnerLink
     */
    updatedAt: Date;
    /**
     * When true the warehouse has waived contract + KYC requirements for this partner
     * (never blocked, no reminders, no KYC row auto-ensured). Rows predating the column read null.
     * @type {boolean}
     * @memberof PartnerLink
     */
    complianceWaived?: boolean | null;
    /**
     * When the waiver was granted (null once reinstated)
     * @type {Date}
     * @memberof PartnerLink
     */
    complianceWaivedAt?: Date | null;
    /**
     * CourierUser id of the warehouse staff member who granted the waiver
     * @type {number}
     * @memberof PartnerLink
     */
    complianceWaivedById?: number | null;
    /**
     * Optional free-text reason for the waiver
     * @type {string}
     * @memberof PartnerLink
     */
    complianceWaivedReason?: string | null;
    /**
     * 
     * @type {Courier}
     * @memberof PartnerLink
     */
    warehouseTenant?: Courier;
    /**
     * 
     * @type {Courier}
     * @memberof PartnerLink
     */
    subCourierTenant?: Courier;
    /**
     * 
     * @type {CourierUser}
     * @memberof PartnerLink
     */
    creator?: CourierUser;
}

/**
 * Check if a given object implements the PartnerLink interface.
 */
export function instanceOfPartnerLink(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "warehouseTenantId" in value;
    isInstance = isInstance && "subCourierTenantId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdBy" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function PartnerLinkFromJSON(json: any): PartnerLink {
    return PartnerLinkFromJSONTyped(json, false);
}

export function PartnerLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'warehouseTenantId': json['warehouseTenantId'],
        'subCourierTenantId': json['subCourierTenantId'],
        'scopes': !exists(json, 'scopes') ? undefined : json['scopes'],
        'status': json['status'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'complianceWaived': !exists(json, 'complianceWaived') ? undefined : json['complianceWaived'],
        'complianceWaivedAt': !exists(json, 'complianceWaivedAt') ? undefined : (json['complianceWaivedAt'] === null ? null : new Date(json['complianceWaivedAt'])),
        'complianceWaivedById': !exists(json, 'complianceWaivedById') ? undefined : json['complianceWaivedById'],
        'complianceWaivedReason': !exists(json, 'complianceWaivedReason') ? undefined : json['complianceWaivedReason'],
        'warehouseTenant': !exists(json, 'warehouseTenant') ? undefined : CourierFromJSON(json['warehouseTenant']),
        'subCourierTenant': !exists(json, 'subCourierTenant') ? undefined : CourierFromJSON(json['subCourierTenant']),
        'creator': !exists(json, 'creator') ? undefined : CourierUserFromJSON(json['creator']),
    };
}

export function PartnerLinkToJSON(value?: PartnerLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'warehouseTenantId': value.warehouseTenantId,
        'subCourierTenantId': value.subCourierTenantId,
        'scopes': value.scopes,
        'status': value.status,
        'createdBy': value.createdBy,
        'createdAt': (value.createdAt.toISOString()),
        'updatedAt': (value.updatedAt.toISOString()),
        'complianceWaived': value.complianceWaived,
        'complianceWaivedAt': value.complianceWaivedAt === undefined ? undefined : (value.complianceWaivedAt === null ? null : value.complianceWaivedAt.toISOString()),
        'complianceWaivedById': value.complianceWaivedById,
        'complianceWaivedReason': value.complianceWaivedReason,
        'warehouseTenant': CourierToJSON(value.warehouseTenant),
        'subCourierTenant': CourierToJSON(value.subCourierTenant),
        'creator': CourierUserToJSON(value.creator),
    };
}
